import { SiteFooter } from "./home/BreathworkAndFooter";

// All pages share the new FERAL footer.
const Footer = () => <SiteFooter />;

export default Footer;
